import React from 'react'
import LearnerProfileSection from './components/LearnerProfileSection'
import HorizontalTab from '../../../../../components/Tab/HorizontalTab'
import CurrentCohort from './components/CurrentCohort';
import OverallHistory from './components/OverallHistory';
import CoursesCompletion from './components/CoursesCompletion';

const LearnerProfile = () => {
    const tabsData = [
        {
          label: `Current Cohort`,
          content: <CurrentCohort />,
        },
        {
          label: `Courses Completion`,
          content: <CoursesCompletion />,
        },
        {
          label: `OverAll History`,
          content: <OverallHistory  />,
        } 
      ];
  return (
    <div className='md:flex gap-6 mt-4'> 
        <div className="w-1/4">
          <LearnerProfileSection />
        </div>
        <div className="w-3/4">
          <HorizontalTab tabsData={tabsData} />
        </div>
    </div>
  )
}

export default LearnerProfile